import type { StatusDoChamado } from "../../types"

const SITUACOES: Record<StatusDoChamado, { rotulo: string; classe: string }> = {
  aberto: { rotulo: "Aberto", classe: "bg-gold-100 text-gold-600" },
  respondido: { rotulo: "Respondido", classe: "bg-emerald-50 text-emerald-700" },
  fechado: { rotulo: "Fechado", classe: "bg-navy-50 text-navy-600" },
}

/** Selo de situação do chamado, igual na lista e na tela do chamado. */
export function Situacao({ status }: { status: StatusDoChamado }) {
  const s = SITUACOES[status]
  return (
    <span className={`shrink-0 rounded-full px-2.5 py-1 font-mono text-[0.65rem] uppercase tracking-wider ${s.classe}`}>
      {s.rotulo}
    </span>
  )
}
